import * as React from 'react';
import { IgcTreeItemComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The tree-item component represents a child item of the tree component or another tree item.
 * @slot  - Renders nested tree-item component.
 * @slot label - Renders the tree item container.
 * @slot indicator - Renders the expand indicator container.
 * @slot loading - Renders the tree item loading indicator container.
 * @slot indentation - Renders the container (by default the space) before the tree item.
 * @csspart wrapper - The wrapper for the tree item.
 * @csspart selected - Indicates selected state. Applies to `wrapper`.
 * @csspart focused - Indicates focused state. Applies to `wrapper`.
 * @csspart active - Indicates an active state. Applies to `wrapper`.
 * @csspart indicator - The expand indicator of the tree item.
 * @csspart label - The tree item content.
 * @csspart text - The tree item displayed text.
 * @csspart select - The checkbox of the tree item when selection is enabled.
 * @class
 */
export const IgrTreeItem = /* @__PURE__ */ createComponent({
  tagName: 'igc-tree-item',
  displayName: 'IgrTreeItem',
  elementClass: Component,
  react: React,
});

export type IgrTreeItem = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTreeItemModule = Component;
